const extractParamsFromUrl = (context, url) => {
	const output = {};
	if (!context) {
		return output;
	}
	if (url) {
		const regex = url.match(context.regex);
		if (regex && regex.groups) {
			Object.assign(output, regex.groups);
		}
	}
	return output;
};

const getConditionalRenderingFields = (context) => context.conditional_rendering_fields;
const hasConditionalRenderingFields = (context) => getConditionalRenderingFields(context).length > 0;
const isSingleton = (context) => context.is_singleton;

const ContextService = {
	extractParamsFromUrl,
	getConditionalRenderingFields,
	hasConditionalRenderingFields,
	isSingleton,
};

export default ContextService;
